import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { LaboratorioService } from '../laboratorio.service';
import {
    DocumentoMuestraLaboratorioSolicitudViewModel,
    SolicitudLaboratorioViewModel,
    TwResultadoEnvioMuestraLaboratorioSolicitudViewModel,
    TwTcResultadoEnvioMuestraLaboratorioEnum,
} from '../laboratorio.types';
import { DocumentModule, UploadedFileViewModel } from '../../../../core/components/uploader/document_uploader.types';
import { catchError, of, tap } from 'rxjs';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { EnumCodigosTwTcAcciones, EnumIdsTcEstadoSolicitud, EnumIdsTwTcTipoClonacion } from '../../types/enum';
import { TcPerfilUsuarioEnum } from '../../../../core/_infrastructure/types/common';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { SolicitudService } from '../../datosbasicos/datosbasicos.service';
import { ConfigurationService } from '../../../../core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-laboratorio-documentos-edit',
    templateUrl: './laboratorio-documentos-edit.component.html',
})
export class LaboratorioDocumentosEditComponent extends ComponentBase implements OnInit, OnDestroy {
    @HostListener('window:beforeunload', ['$event'])
    forceCheckUnload(): boolean {
        // Prevenimos la pérdida de datos, si el usuario recarga accidentalmente la página.
        // Lo controlamos y el navegador le requiere confirmación para finalizar la recarga.
        if (this.filePendingToPurge !== '') {
            this.laboratorioService.deleteFile(this.filePendingToPurge).subscribe();
        }
        return false;
    }

    isCollapsedCabecera = false;
    visibilitySpinner = false;

    esPerfilInspectorOrGrabador = false;
    esPerfilConsultasyLaboratorio = false;
    habilitarGuardar = false;

    idSolicitud: number;
    solicitudLaboratorio: SolicitudLaboratorioViewModel;
    idTipoSolicitud: number;
    tituloTipoSolicitud: string;
    esClonada = false;

    formGroup: FormGroup;
    uploadedFile: UploadedFileViewModel;
    payload: DocumentoMuestraLaboratorioSolicitudViewModel;

    resultadoMuestrasLaboratorio: TwResultadoEnvioMuestraLaboratorioSolicitudViewModel;
    documentosLaboratorio: DocumentoMuestraLaboratorioSolicitudViewModel[];

    idDocumento: number;
    editMode = false;
    documentoLaboratorio: DocumentoMuestraLaboratorioSolicitudViewModel;

    documentModuleLaboratorio = DocumentModule.Laboratorio;

    envioMuestrasCerrado = false;

    private successMessage = 'Documentación guardada correctamente';
    private fileSuccessMessage = 'Documentación cargada. Recuerde GUARDAR antes de abandonar la pantalla';

    private filePendingToPurge = '';
    private docLoaded = false;
    megaSizeLimit = 0;

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const idSolicitud = params.get('id');
        const idDocumento = params.get('idDocumento');

        if (idSolicitud) {
            this.idSolicitud = parseInt(idSolicitud);

            if (this.idSolicitud) {
                this.getSolicitudLaboratorio();
            }
        }

        if (idDocumento) {
            this.idDocumento = parseInt(idDocumento);
            this.editMode = true;
            this.getDocumentoSolicitudLaboratorio();
        }
    });

    constructor(
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private fb: FormBuilder,
        private router: Router,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private laboratorioService: LaboratorioService,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
        protected configService: ConfigurationService,
    ) {
        super(authService, notificationService, exceptionHandler, configService);
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    ngOnInit(): void {
        //RDLF: 170325 Ahora el grabador tiene los mismos permisos que el inspector (tarea 166779)
        this.esPerfilInspectorOrGrabador =
            this.isInspector || this.isGrabador;
        this.esPerfilConsultasyLaboratorio =
            this.isConsultas && this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Laboratorio);

        this.guardRefreshPage(this.idSolicitud);

        this.buildForm();
        this.initComponent();

        this.MegaSizeLimitsCargado$.subscribe(() => {
            this.megaSizeLimit = this.getValorSizeLimit('laboratorio-documentos-edit');
        });
    }

    private initComponent(): void {
        this.buildForm();
        this.createPayload();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            Texto: '',
            NombreArchivo: ['', Validators.required],
        });
        this.form = this.formGroup;
    }

    private getSolicitudLaboratorio(): void {
        this.laboratorioService.getSolicitudLaboratorio(this.idSolicitud).subscribe(res => {
            this.loading = false;
            this.solicitudLaboratorio = res;
            this.idTipoSolicitud = this.solicitudLaboratorio.IdTipoSolicitud;
            this.tituloTipoSolicitud = this.solicitudLaboratorio.IdTipoSolicitudDescripcion;

            this.esClonada =
                this.solicitudLaboratorio.TwSolicitudJerarquia != null &&
                this.solicitudLaboratorio.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            //Si es Re-Importación
            if (this.solicitudLaboratorio.EsReImportacion) {
                this.tituloTipoSolicitud += ' - Re-Importación';
            }
            //Si es previa
            if (this.solicitudLaboratorio.EsPrevia) {
                if (
                    this.solicitudLaboratorio.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                    this.solicitudLaboratorio.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                ) {
                    this.tituloTipoSolicitud += ' - Previa';
                }
            }

            this.documentosLaboratorio = res.TwDocumentoMuestraLaboratorioSolicitudCollection;

            this.resultadoMuestrasLaboratorio = res.TwResultadoEnvioMuestraLaboratorioSolicitud;

            if (this.resultadoMuestrasLaboratorio) {
                if (
                    this.resultadoMuestrasLaboratorio.IdResultado == TwTcResultadoEnvioMuestraLaboratorioEnum.Aceptada ||
                    this.resultadoMuestrasLaboratorio.IdResultado == TwTcResultadoEnvioMuestraLaboratorioEnum.Rechazada
                ) {
                    this.envioMuestrasCerrado = true;
                }
            }

            this.habilitarGuardar =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_LABORATORIO, this.solicitudLaboratorio.IdEstadoSolicitud).Visible &&
                !this.envioMuestrasCerrado;
        });
    }

    private createPayload(): void {
        this.payload = new DocumentoMuestraLaboratorioSolicitudViewModel();
        this.uploadedFile = new UploadedFileViewModel();

        this.payload.Id = null;
        this.payload.IdSolicitud = this.idSolicitud;
        this.payload.IdUsuario = null;
        this.payload.Fecha = null;
        this.payload.MarkToDelete = 0;

        this.updateForm();
    }

    private updatePayload(): void {
        this.payload = new DocumentoMuestraLaboratorioSolicitudViewModel();
        this.uploadedFile = new UploadedFileViewModel();

        this.payload.Id = this.idDocumento;
        this.payload.IdSolicitud = this.documentoLaboratorio.IdSolicitud;
        this.payload.Fecha = this.documentoLaboratorio.Fecha;
        this.payload.IdUsuario = this.documentoLaboratorio.IdUsuario;
        this.payload.MarkToDelete = this.documentoLaboratorio.MarkToDelete;
        this.payload.CodigoStorage = this.documentoLaboratorio.CodigoStorage;
        this.payload.Texto = this.documentoLaboratorio.Texto;
        this.payload.Size = this.documentoLaboratorio.Size;
        this.payload.NombreArchivo = this.documentoLaboratorio.NombreArchivo;
        this.payload.IdDocFileSystem = this.documentoLaboratorio.IdDocFileSystem;

        this.uploadedFile.Guid = this.documentoLaboratorio.CodigoStorage;
        this.uploadedFile.Name = this.documentoLaboratorio.NombreArchivo;
        this.uploadedFile.Size = this.documentoLaboratorio.Size;

        this.updateForm();
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            Texto: this.payload.Texto,
            NombreArchivo: this.payload.NombreArchivo,
        });
        this.cdr.detectChanges();
    }

    onFileUploaded(uploadedFile: UploadedFileViewModel): void {
        this.payload.CodigoStorage = uploadedFile.Guid;
        this.payload.NombreArchivo = uploadedFile.Name;
        this.payload.Size = uploadedFile.Size;
        this.payload.IdUsuario = this.loggedInUser!.Id;

        if (this.filePendingToPurge !== '') {
            this.laboratorioService.deleteFile(this.filePendingToPurge).subscribe();
        }
        this.filePendingToPurge = uploadedFile.Guid;

        this.addSuccessMessage(this.fileSuccessMessage);

        //en Uploader Local obtenemos el valor para este campo obligatorio en subida local
        this.form.controls['NombreArchivo'].setValue(this.uploadedFile!.Name);

        this.formGroup.markAsPristine();
        this.docLoaded = true;
    }

    get ficheroSubido(): boolean {
        return this.uploadedFile.Guid !== undefined && this.uploadedFile.Guid !== null && this.uploadedFile.Guid !== '' && !this.uploadedFile.MarkToDelete;
    }

    onFileDeleted(deletedFile: UploadedFileViewModel) {
        this.uploadedFile = deletedFile;
    }

    onClickSave(): void {
        this.payload.Texto = this.formGroup.value.Texto;

        if (!this.formGroup.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        if (this.uploadedFile.Name == '' || this.uploadedFile.MarkToDelete) {
            this.addErrorMessage('Debe cargar el documento antes de guardar');
            return;
        }

        this.laboratorioService
            .persist(this.payload)
            .pipe(
                tap(() => {
                    this.visibilitySpinner = false;
                    this.formGroup.markAsPristine();
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack() {
        this.router.navigate([`/importacion/solicitud/laboratorio/${this.idSolicitud}`]);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.pristine || !this.docLoaded;
    }

    getDocumentoSolicitudLaboratorio(): void {
        this.laboratorioService.getDocumentoLaboratorio(this.idDocumento).subscribe(res => {
            this.documentoLaboratorio = res;
            this.updatePayload();
        });
    }

    get title(): string {
        if (this.editMode) {
            return 'Editar';
        } else {
            return 'Nuevo';
        }
    }

    ngOnDestroy(): void {
        if (this.filePendingToPurge !== '') {
            this.laboratorioService.deleteFile(this.filePendingToPurge).subscribe();
        }
    }
}
